import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';
import type { EmployeeEducation } from '@/types/Psychosocial';

interface GetEmployeeEducationListParams {
	company_id: string;
}

const Service = PsychosocialReportService.getInstance();

const handleTransformSelect = (data: EmployeeEducation[]) => {
	return data.map((education) => ({
		value: education.id,
		label: education.name
	}));
};

export const useGetEmployeeEducationList = (params: GetEmployeeEducationListParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_PSYCHOSOCIAL_EMPLOYEE_EDUCATION_LIST, params],
		queryFn: async () => Service.getEmployeeEducationsList(params),
		enabled: !!params.company_id,
		select: handleTransformSelect
	});
};
